import { combineReducers } from "redux";
import { EmployeeBankReducer } from "./Bank/Reducer";
import { EmployeeFamilyReducer } from "./Family/Reducer";
import { EmployeeBasicReducer } from "./Basic/Reducer"
import { EmployeeProfessionalSummaryReducer } from "./ProfessionalSummary/Reducer";
import { EmployeePersonalReducer } from "./Personal/Reducer";
import { EmployeeOtherPersonalReducer } from "./OtherPersonal/Reducer";
import { EmployeesReducer } from "./Employee/Reducer";
import { EmployeeWorkDetailReducer } from "./WorkDetail/Reducer";
import { EmployeePayrollDetailsReducer } from "./Payroll/Reducer";
import { EmployeePayrollProfileDetailReducer } from "./PayrollProfile/Reducer";
import { VisitorsReducer } from "./Visitors/Reducer";
import { ManageGoalReducer } from "./PMSystem/Reducer";
import { PmsFeedbackReducer } from "./PMSFeedback/Reducer";
import { GoalReducer } from "./PMSSetting/Reducer";
import { ECMSReducer } from "./ECMS/Reducer";
import { EmployeeClearanceReducer } from "./EmployeeClearance/Reducer";
import { ECMSAdminActionReducer } from "./EcmsAdmin/Reducer";
import { EmployeeCanteenReducer } from "./Canteen/Reducer";
import { EACUsersReducer } from "./User/Reducer"

const EmployeeReducer = combineReducers({
    EmployeesReducer,
    EmployeeBasicReducer,
    EmployeeBankReducer,
    EmployeeFamilyReducer,
    EmployeeProfessionalSummaryReducer,
    EmployeeWorkDetailReducer,
    EmployeePersonalReducer,
    EmployeeOtherPersonalReducer,
    EmployeePayrollDetailsReducer,
    EmployeePayrollProfileDetailReducer,
    VisitorsReducer,
    ManageGoalReducer,
    PmsFeedbackReducer,
    GoalReducer,
    ECMSReducer,
    EmployeeClearanceReducer,
    ECMSAdminActionReducer,
    EmployeeCanteenReducer,
    EACUsersReducer
});

export default EmployeeReducer;